import React, { useEffect, useState, useRef } from "react";

// libs
import { get } from "lodash-es";

// Hooks
import { useProducts } from "../../../../hooks/api/fulfillment/products";
import useOrderCreateFlow from "../../../../hooks/reduxContainer/fulfillment/orderCreateFlow";
import { useParams } from "react-router";

// Components
import { SelectProducts } from "@secondcloset/web-components";

// Interfaces
import { Fulfillment } from "@secondcloset/types";

type Product = Fulfillment.Product;

interface ProductItem extends Product {
  quantity: number;
}

const SelectProductsStep: React.FC = () => {
  const [search, setSearch] = useState("");
  const { products, fetchProducts } = useProducts();
  const { itemList, dispatchItemList } = useOrderCreateFlow();
  const params = useParams();
  const organizationID = get(params, "organization_id");
  const searchRef = useRef(false);

  const searchProducts = () => {
    if (!searchRef.current) {
      searchRef.current = true;
      return;
    }
    if (searchRef.current) {
      fetchProducts({
        q: search,
        active: true,
        organization_id: organizationID,
        per_page: 100,
      });
    }
  };

  useEffect(searchProducts, [search]);

  const addNewItem = (productItem: ProductItem) => {
    const isExisted = !!itemList.find((i) => i.id === productItem.id);
    if (isExisted) return;
    dispatchItemList([...itemList, productItem]);
    searchRef.current = false;
  };

  const removeItem = (productItem: ProductItem) => {
    const updatedItemList = itemList.filter((item) => item.id !== productItem.id);
    dispatchItemList([...updatedItemList]);
  };

  const itemQuantityChange = (productItem: ProductItem, updatedQuantity: number) => {
    const item = itemList.find((item) => item.id === productItem.id);
    item.quantity = updatedQuantity;
    dispatchItemList([...itemList]);
  };

  const onSkuClicked = (product: Product) => {
    if (product) window.open(`/organizations/${organizationID}/products/${product.id}`);
  };

  const getQueryProducts = () => {
    const filteredResult = products.data?.filter((product) => !itemList.some((item) => item.id === product.id));
    return (filteredResult as unknown as Product[]) || [];
  };

  return (
    <div style={{ margin: " 0 0 120px 0" }}>
      <SelectProducts
        itemList={itemList}
        searchResults={getQueryProducts()}
        searchLoading={products.loading}
        addNewItem={addNewItem}
        removeItem={removeItem}
        itemQuantityChange={itemQuantityChange}
        onProductSearch={(searchString: string) => setSearch(searchString)}
        onSkuClick={onSkuClicked}
      ></SelectProducts>
    </div>
  );
};

export default SelectProductsStep;
